export default {
  quoteText: "Wisdom begins in wonder.",
  quoteBy: "Socrates"
};
